module.exports = __webpack_public_path__ + "cart-unlocked-discount/cart-unlocked-discount-04c1481192b7e31df7929a2bdd959d63.svg";